import axios from 'axios';


let hostname = window.location.hostname

let config = {};

console.log(window.location.hostname);

if (hostname == "pay.zghbqn.com") {
    config = {
        baseURL: 'https://game.zghbqn.com/', // 设置基础URL
        timeout: 10000, // 请求超时时间
    };
} else if (hostname == "pay.xyhy.live") {
    config = {
        baseURL: 'https://payapi.xyhy.live/', // 设置基础URL
        timeout: 10000, // 请求超时时间
    }
} else {
    config = {
        baseURL: 'https://game.zghbqn.com/', // 设置基础URL
        timeout: 10000, // 请求超时时间
    }
}

const http = axios.create(config)

// 添加请求拦截器
http.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，例如添加token
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
http.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response;
    },
    error => {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default http;
